/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Event_Disapproved_HintInputs */

const en_error_nav_event_disapproved_hint = /** @type {(inputs: Error_Nav_Event_Disapproved_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review the Event content and approve if correct.`)
};

const fr_error_nav_event_disapproved_hint = /** @type {(inputs: Error_Nav_Event_Disapproved_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revoyez le contenu de l'evenement et approuvez-le si correct.`)
};

const de_error_nav_event_disapproved_hint = /** @type {(inputs: Error_Nav_Event_Disapproved_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfen Sie den Veranstaltungsinhalt und genehmigen Sie ihn, falls er korrekt ist.`)
};

const it_error_nav_event_disapproved_hint = /** @type {(inputs: Error_Nav_Event_Disapproved_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esaminare il contenuto dell'evento e approvarlo se corretto.`)
};

const ru_error_nav_event_disapproved_hint = /** @type {(inputs: Error_Nav_Event_Disapproved_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверьте содержание мероприятия и подтвердите его, если оно соответствует требованиям.`)
};

const es_error_nav_event_disapproved_hint = /** @type {(inputs: Error_Nav_Event_Disapproved_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revise el contenido del evento y apruebe si es correcto.`)
};

const zh_cn2_error_nav_event_disapproved_hint = /** @type {(inputs: Error_Nav_Event_Disapproved_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审核活动内容，如果正确，请批准。`)
};

const ja_error_nav_event_disapproved_hint = /** @type {(inputs: Error_Nav_Event_Disapproved_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの内容を確認し、正しい場合は承認します。`)
};

const hi_error_nav_event_disapproved_hint = /** @type {(inputs: Error_Nav_Event_Disapproved_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट की सामग्री की समीक्षा करें और सही होने पर उसे अनुमोदित करें।`)
};

const pt_pt2_error_nav_event_disapproved_hint = /** @type {(inputs: Error_Nav_Event_Disapproved_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analise o conteúdo do evento e aprove-o se estiver correto.`)
};

/**
* | output |
* | --- |
* | "Review the Event content and approve if correct." |
*
* @param {Error_Nav_Event_Disapproved_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_event_disapproved_hint = /** @type {((inputs?: Error_Nav_Event_Disapproved_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Event_Disapproved_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_event_disapproved_hint(inputs)
	if (locale === "de") return de_error_nav_event_disapproved_hint(inputs)
	if (locale === "it") return it_error_nav_event_disapproved_hint(inputs)
	if (locale === "ru") return ru_error_nav_event_disapproved_hint(inputs)
	if (locale === "es") return es_error_nav_event_disapproved_hint(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_event_disapproved_hint(inputs)
	if (locale === "ja") return ja_error_nav_event_disapproved_hint(inputs)
	if (locale === "hi") return hi_error_nav_event_disapproved_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_event_disapproved_hint(inputs)
	return en_error_nav_event_disapproved_hint(inputs)
});